import { localizationEnUsAccount, routerPageAccount } from "./account";
import { localizationEnUsAccounts, routerPageAccounts } from "./accounts";
import { localizationEnUsEmployee, routerPageEmployee } from "./employee";
import { localizationEnUsEmployees, routerPageEmployees } from "./employees";
import {
  localizationEnUsBusinessUnit,
  routersPageBusinessUnit,
} from "./business-unit";
import {
  localizationEnUsBusinessUnits,
  routersPageBusinessUnits,
} from "./business-units";

export const localizationEnUsCompany = {
  ...localizationEnUsAccount,
  ...localizationEnUsAccounts,
  ...localizationEnUsEmployee,
  ...localizationEnUsEmployees,
  ...localizationEnUsBusinessUnit,
  ...localizationEnUsBusinessUnits,
};

export const routersPageCompany = [
  routerPageAccount,
  routerPageAccounts,
  routerPageEmployee,
  routerPageEmployees,
  ...routersPageBusinessUnit,
  ...routersPageBusinessUnits,
];
